import script from "./whiteOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./whiteOverlay.vue?vue&type=script&setup=true&lang=js"

import "./whiteOverlay.vue?vue&type=style&index=0&id=baafb658&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-production-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-baafb658"]])

export default __exports__